export const ok = (store, res, fnOk) => {
  if (res.status === 200 && res.data.code === "OK") fnOk(res.data.data);
  else {
    console.log(res);
    if (res.data.code === "RELOGIN") {
      store.rootStore.authStore.logout();
    }
    alert(res.data.message);
  }
  return res.data;
};
